<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-02 19:29:11
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-10-11 10:04:00
--> 
<template>
  <div>
    <staffOfficial></staffOfficial>
  </div>
</template> 
 
<script>
import staffOfficial from './staffType.vue'
export default {
  components: {
    staffOfficial
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {

  },
  watch: {
  }
}
</script>